import {
  FormControl,
  FormHelperText,
  FormLabel,
  Select
} from '@material-ui/core'
import { ChevronDown } from 'lucide-react'
import { useStyles } from './style'

export default function SelectInput({
  error,
  helperText,
  label,
  id,
  name,
  value,
  onChange,
  children,
  MenuProps,
  select,
  size = 'medium',
  ...rest
}) {
  const classes = useStyles()
  const safeValue = value === undefined || value === null ? '' : value

  const defaultMenuProps = {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    getContentAnchorEl: null,
    MenuListProps: {
      className: classes.menuList
    }
  }

  const mergedMenuProps = {
    ...defaultMenuProps,
    ...MenuProps,
    PaperProps: {
      ...defaultMenuProps.PaperProps,
      ...MenuProps?.PaperProps
    },
    MenuListProps: {
      ...defaultMenuProps.MenuListProps,
      ...MenuProps?.MenuListProps,
      className: `${classes.menuList} ${
        MenuProps?.MenuListProps?.className || ''
      }`
    }
  }

  return (
    <FormControl
      error={error}
      fullWidth
      className={`${classes.formControl} ${size === 'small' ? 'small' : ''}`}
    >
      {label && (
        <FormLabel id={label} htmlFor={label} className={classes.label}>
          {label}
        </FormLabel>
      )}
      <Select
        {...rest}
        labelId={label}
        id={id || label}
        displayEmpty
        name={name}
        variant="outlined"
        value={safeValue}
        onChange={onChange}
        IconComponent={ChevronDown}
        MenuProps={mergedMenuProps}
        margin={size === 'small' ? 'dense' : 'none'}
        classes={{
          icon: classes.iconChevronDown,
          select: classes.selectText,
          selectMenu: classes.selectText
        }}
      >
        {children}
      </Select>
      {error && helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}
